import { render, staticRenderFns } from "./CodeHighlight.vue?vue&type=template&id=17bddf9c"
import script from "./CodeHighlight.vue?vue&type=script&lang=js"
export * from "./CodeHighlight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17bddf9c')) {
      api.createRecord('17bddf9c', component.options)
    } else {
      api.reload('17bddf9c', component.options)
    }
    module.hot.accept("./CodeHighlight.vue?vue&type=template&id=17bddf9c", function () {
      api.rerender('17bddf9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/syntax/CodeHighlight.vue"
export default component.exports